export default __webpack_public_path__ + "static/media/photo--lg--27.ab402098.jpg";